import { render } from "./OffsetStore.vue?vue&type=template&id=d05a5f9c&scoped=true&lang=true"
import script from "./OffsetStore.vue?vue&type=script&lang=js"
export * from "./OffsetStore.vue?vue&type=script&lang=js"

import "./OffsetStore.vue?vue&type=style&index=0&id=d05a5f9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05a5f9c"]])

export default __exports__